// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';


let defaultControlsConfig = {};

exports.defaultControlsConfig = defaultControlsConfig;
/* No side effect */
